<template>
	<div class="page">
		<!-- your page -->
		<Head></Head>
		<!-- <div class="banner">
			<img src="../../assets/article/banner.png" alt="">
		</div> -->
		<div class="article" v-if="success">
			<div class="fixation">
				<div class="title">
					{{title}}
				</div>
				<!-- <div class="time">
					{{time}}
				</div> -->
				<div class="content" v-html="content"></div>
			</div>
		</div>
		<div class="error" v-if="!success">
			<div class="fixation">
				<div class="errorBox">
					<img src="../../assets/article/error.png" alt="">
				</div>
				<div class="errorWord">没有找到文章内容，可能已经被删除</div>
			</div>
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
	// your script
	import Head from '../../components/head.vue'
	import Foot from '../../components/foot.vue'
	export default {
		name: 'theArticle',
		components:{
			Head,Foot
		},
		data(){
			return {
				title:"",
				time:"",
				content:"",
				success:true
			}
		},
		methods:{
			fetchData(){
				var data = {}
				if(this.type=='article'){
					data['method']="articles.getArticleDetail",
					data['article_id']=this.id
				}else if(this.type=='notice'){
					data['method']='notice.noticeInfo'
					data['id']=this.id
				}
				var that = this
				this.request(data,(res)=>{
					console.log(res)
					if(res.status){
						that.time = res.data.ctime
						that.content = res.data.content.replace(/\<img/gi, '<img style="max-width:100%;height:auto"')
						that.title = res.data.title
					}else{
						that.success = false
						that.globalTest('articles.getArticleDetail','error',res.msg,res.data)
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.id = this.$route.query.aid
			this.type = this.$route.query.type
			this.fetchData()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	}
</script>

<style scoped>
	/* your css */
	.banner{
		width: 100%;
	}
	.banner img{
		width: 100%;
		display: block;
	}
	.fixation{
		position: relative;
	}
	.article{
		width: 100%;
		padding-top: 30px;
	}
	.title{
		width: 100%;
		padding: 15px 0px;
		box-sizing: border-box;
		line-height: 30px;
		font-size: 24px;
		color: #0053B8;
		text-align: center;
		font-weight: 600;
	}
	.time{
		width: 100%;
		height: 40px;
		text-align: center;
		font-size: 16px;
		color: #838383;
	}
	.content{
		width: 100%;
	}
	.content img{
		width: 800px;
	}
	.errorBox{
		width: 100%;
	}
	.errorBox img{
		width: 40%;
		display: block;
		margin: 0 auto;
	}
	.errorWord{
		width: 100%;
		height: 60px;
		line-height: 60px;
		font-size: 24px;
		font-weight: 600;
		position: absolute;
		bottom: 50px;
		left: 0px;
		text-align: center;
		color:#0053B8;
	}
</style>
